import CategoryModal from "./category-modal.component";

export default CategoryModal;
